import { useAuth } from "../auth"

import { Link } from "react-router-dom"
import { Formik, getIn } from "formik"
import yup from "../utils/validations"
import { Button, CharField, H2, PasswordField } from "@inmagik/magik-ui"

const schema = yup.object().shape({
  email: yup.string().email().required().label("Email"),
  password: yup.string().required().label("Password"),
})

const initialValues = {
  email: "",
  password: "",
}

export function Login() {
  const { performLogin, loginError } = useAuth()

  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        backgroundImage: "url(/sfondo.png)",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "100vh",
      }}
    >
      <Formik
        validationSchema={schema}
        initialValues={initialValues}
        enableReinitialize
        onSubmit={(values) => {
          performLogin(values)
        }}
      >
        {({ handleSubmit, touched, errors, isSubmitting, values, setFieldValue, submitCount }) => (
          <form
            onSubmit={handleSubmit}
            className="w-100 h-100 d-flex flex-column align-items-center justify-content-center"
          >
            <div
              style={{
                borderRadius: "1rem",
                border: "1px solid #fafafa",
                background: "linear-gradient(145deg, rgba(255, 255, 255, 0.4) 2.91%, rgba(255, 255, 255, 0.8) 97.55%)",
                boxShadow: "0px 4px 24px -1px rgba(0, 0, 0, 0.15)",
                backdropFilter: "blur(10px)",
                display: "flex",
                width: "464px",
                padding: "32px",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "40px",
                height: "max-content",
              }}
            >
              <div className="d-flex flex-column align-items-center">
                <H2 className="text-center">Login</H2>
              </div>
              <div className="w-100">
                <CharField
                  label="Email"
                  className="mb-2"
                  placeholder="Inserisci la tua email"
                  required
                  value={values.email}
                  onChange={(value) => {
                    setFieldValue("email", value)
                  }}
                  isValid={submitCount > 0 ? !getIn(errors, "email") : undefined}
                  errorMessage={getIn(errors, "email")}
                />
                <PasswordField
                  label="Password"
                  placeholder="Inserisci la tua password"
                  required
                  value={values.password}
                  onChange={(value) => {
                    setFieldValue("password", value)
                  }}
                  isValid={submitCount > 0 ? !getIn(errors, "password") : undefined}
                  errorMessage={getIn(errors, "password")}
                />
              </div>
              <div className="mt-2 text-end">
                <Link to="/password-dimenticata" className="text-danger no-link p-md">
                  Password dimenticata?
                </Link>
              </div>

              <div>
                {loginError && <div className="alert alert-danger mt-2 py-1">Credeziali non valide. Riprova.</div>}
              </div>

              <Button
                type="submit"
                size="md"
                variant="primary"
                disabled={isSubmitting && !loginError}
                className="w-100 mt-2 text-white d-flex align-items-center justify-content-center"
                title="Accedi"
              />
            </div>
          </form>
        )}
      </Formik>
    </div>
  )
}
